import React, { useState, useEffect, useContext, useMemo } from "react";
import URLstateContext from "../../../../provider/CommonContext";
import { Col, Container, Row } from 'react-bootstrap';
import './PutCallRatio.css';
import Pagination from '../../../CommonUI/Pagination/Pagination';
import { format, parseISO } from 'date-fns';
import MarketFandO from "../../MarketFandO";
import { Vortex } from 'react-loader-spinner'

function PutCallRatio() {

    const [data, setData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [dataSym, setDataSym] = useState([]);
    const [dataExp, setDataExp] = useState([]);
    const [optBtn, setOpteBtn] = useState("-");
    const [expDate, setExpDate] = useState("-");
    const [symbol, setSymbol] = useState("-");    
    const { BaseURL } = useContext(URLstateContext);
    const [loadingshow, setloadingshow] = useState(false);
    let getData, getDataSym, getDataExp;
    let PageSize = 8;


    useEffect(() => {
        window.scrollTo(0, 0)
        setloadingshow(true);
        const getUrl = BaseURL + "Putcallratio";
        fetch(`${getUrl}/${optBtn}/${expDate}/${symbol}/-`)
            .then((response) => response.json())
            .then((data) => {
                getData = data.data;
                setData(getData);
                setloadingshow(false);
                //console.log(getData, "getData")
            })
            .catch((error) => {
            });
    }, [optBtn, expDate, symbol]);

    useEffect(() => {
        const getUrl = BaseURL + "FandOExpDateandSymbol";
        fetch(`${getUrl}/Sym/-`)
            .then((response) => response.json())
            .then((dataS) => {
                getDataSym = dataS.data;
                setDataSym(getDataSym);
                setloadingshow(false);
                //console.log("data:", getDataSym);
            })
            .catch((error) => {
                // console.log("not found the api");
            });
        const getUrlExp = BaseURL + "FandOExpDateandSymbol";
        fetch(`${getUrlExp}/OPT/${symbol}`)
            .then((response) => response.json())
            .then((dataE) => {
                getDataExp = dataE.data;
                setDataExp(getDataExp);
                setloadingshow(false);
                // console.log("data:", getDataExp);
            })
            .catch((error) => {
                // console.log("not found the api");
            });
    }, [symbol]);




    const currentTableData = useMemo(() => {
        if (data != null && data != []) {
            const firstPageIndex = (currentPage - 1) * PageSize;
            const lastPageIndex = firstPageIndex + PageSize;
            if (data != null && data != []) {
                if (data.length > 0) {
                    return data.slice(firstPageIndex, lastPageIndex);
                }
            }
        }
    }, [currentPage, data]);


    return (
        <>
            <div class="col-12 p-0 breadcrumMF ">
                <ul>
                    <li><a href="/">Home</a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                    <li><a href="/market/futures-and-options">F & O</a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                    <li>Put Call Ratio</li>
                </ul>
            </div>
            <Container>
                <Row>
                    <Col sm={12}>
                        <section className='PutCall-loser-sc'>
                            <div className='PutCall-header'>
                                <h2><span>Put Call Ratio</span></h2>
                            </div>
                            <MarketFandO optionValue="Put Call Ratio" optionDrop="Derivative" />
                            <div className='PutCall-right'>
                                <div className='RatPutCall-inner-select'>
                                    
                                    {/* aria-label="Volume & OI" */}
                                    <select aria-label="Volume & OI" onChange={(event) => { setOpteBtn(event.target.value); }}>
                                        <option value="-" selected>Volume & OI</option>
                                        <option value="Vol">Volume</option>
                                        <option value="OI">Open Interest</option>

                                    </select>
                                </div>
                                <div className='PutCall-inner-select'>

                                    {/* aria-label="Select Symbol" */}
                                    <select aria-label="Select Symbol" onChange={(event) => { setSymbol(event.target.value) }}>
                                        <option value="-">Select Symbol</option>
                                        {dataSym && dataSym.map(({ symbol }) => (
                                            <option value={symbol.trim()}>{symbol}</option>
                                        )
                                        )}
                                    </select>
                                </div>
                                <div className='PutCall-inner-select'>
                                    
                                    {/* aria-label="Select Expiry Date" */}
                                    <select aria-label="Select Expiry Date" onChange={(event) => { setExpDate(event.target.value) }}>
                                        <option value="-">Select Expiry Date</option>
                                        {dataExp && dataExp.map(({ ExpiryDateText }) => (
                                            <option value={ExpiryDateText.split(' ').join('-')}>{ExpiryDateText.split(' ').join('-')}</option>
                                        )
                                        )}
                                    </select>
                                </div>

                            </div>

                            {/* <hr className="Mosthr"></hr> */}
                            <div className='PutCall-table table-responsive'>
                                <table className='table'>
                                    {(() => {
                                        if (optBtn === "-") {
                                            return (
                                                <>
                                                    <thead>
                                                        <tr>

                                                            <th className="bdrright text-left" >Symbol</th>
                                                            <th className="bdrright text-right">Expiry Date</th>
                                                            <th className="bdrright text-center bdrbottom" colspan="4" >Volume</th>
                                                            <th class="text-center bdrbottom" colspan="4">Open Interest</th>
                                                            <hr></hr>

                                                        </tr>
                                                        <tr>
                                                            <th className="bdrright"> </th>
                                                            <th className="bdrright"> </th>
                                                            <th className="bdrright text-right">Put</th>
                                                            <th className="bdrright text-right">Call</th>
                                                            <th className="bdrright text-right">Total</th>
                                                            <th className="bdrright text-right">Ratio</th>
                                                            <th className="bdrright text-right">Put</th>
                                                            <th className="bdrright text-right">Call</th>
                                                            <th className="bdrright text-right">Total</th>
                                                            <th class='text-right'>Ratio</th>
                                                        </tr>
                                                    </thead>
                                                    {(data === null) ? <div className="errorMsg"><h3>No Data Found !!!</h3></div> : ''}
                                                    <tbody>
                                                        {currentTableData && currentTableData.map(

                                                            ({ Symbol, expdate, PutQty, PutOI, CallQty, CallOI, TotQty, TotOI, PCRatioQty, PCRatioOI }) => (
                                                                <tr>
                                                                    <td className="text-left">{Symbol}</td>
                                                                    <td className="text-right"> {(expdate != null) ? format(parseISO(expdate), 'dd-MMM-yyyy') : 0}</td>
                                                                    <td className='text-right'>{(PutQty != null) ? PutQty : 0}</td>
                                                                    <td className='text-right'>{(CallQty != null) ? CallQty : 0}</td>
                                                                    <td className='text-right'>{(TotQty != null) ? TotQty : 0}</td>
                                                                    <td className='text-right'>{(PCRatioQty != null) ? PCRatioQty.toFixed(2) : 0}</td>
                                                                    <td className='text-right'>{(PutOI != null) ? PutOI : 0}</td>
                                                                    <td className='text-right'>{(CallOI != null) ? CallOI : 0}</td>
                                                                    <td className='text-right'>{(TotOI != null) ? TotOI : 0}</td>
                                                                    <td className='text-right'>{(PCRatioOI != null) ? PCRatioOI.toFixed(2) : 0}</td>
                                                                </tr>
                                                            ))}
                                                    </tbody>
                                                </>)
                                        } else {
                                            return (
                                                <>
                                                    <thead>

                                                        <tr>
                                                            <th className='text-left'>Symbol</th>
                                                            <th className='text-right'>Expiry Date</th>
                                                            <th className='text-right'>Put</th>
                                                            <th className='text-right'>Call</th>
                                                            <th className='text-right'>Total</th>
                                                            <th className='text-right'>Ratio</th>
                                                        </tr>
                                                    </thead>
                                                    {/* {(data === null) ? <div className="errorMsg"><h3>No Data Found !!!</h3></div> : ''} */}
                                                    <tbody>
                                                        {currentTableData && currentTableData.map(

                                                            ({ Symbol, expdate, PutQty, PutOI, CallQty, CallOI, TotQty, TotOI, PCRatioQty, PCRatioOI }) => (
                                                                <tr>
                                                                    <td className="text-left">{Symbol}</td>
                                                                    <td className="text-right"> {(expdate != null) ? format(parseISO(expdate), 'dd-MMM-yyyy') : 0}</td>
                                                                    {(optBtn === "Vol") ? <td className='text-right'>{(PutQty != null) ? PutQty : 0}</td> :
                                                                        <td className='text-right'>{(PutOI != null) ? PutOI : 0}</td>}
                                                                    {(optBtn === "Vol") ? <td className='text-right'>{(CallQty != null) ? CallQty : 0}</td> :
                                                                        <td className='text-right'>{(CallOI != null) ? CallOI : 0}</td>}
                                                                    {(optBtn === "Vol") ? <td className='text-right'>{(TotQty != null) ? TotQty : 0}</td> :
                                                                        <td className='text-right'>{(TotOI != null) ? TotOI : 0}</td>}
                                                                    {(optBtn === "Vol") ? <td className='text-right'>{(PCRatioQty != null) ? PCRatioQty.toFixed(2) : 0}</td> :
                                                                        <td className='text-right'>{(PCRatioOI != null) ? PCRatioOI.toFixed(2) : 0}</td>}
                                                                </tr>
                                                            ))}
                                                    </tbody>
                                                </>)
                                        }
                                    })()}
                                </table >
                                {loadingshow ? <div className="textcentervertex">
                                                        <Vortex
                                                            visible={true}
                                                            height="80"
                                                            width="80"
                                                            ariaLabel="vortex-loading"
                                                            wrapperStyle={{}}
                                                            wrapperClass="vortex-wrapper"
                                                            colors={['#0473ea', '#0473ea', '#0473ea', '#39d800', '#39d800', '#39d800']}
                                                        />
                                                        <div className="model_popup">Please Wait...</div>
                                                    </div> : ""
                                                    }

                            </div>
                            {(data != null && data != []) ?
                                <Pagination
                                    className="pagination-bar_peer"
                                    currentPage={currentPage}
                                    totalCount={(data.length != null) ? data.length : 0}
                                    pageSize={PageSize}
                                    onPageChange={page => setCurrentPage(page)}
                                /> : <p className="errorPeer"> No Data Found !!! </p>}

                        </section>
                    </Col>
                </Row>
            </Container>
        </>
    );
}

export default PutCallRatio;